import { ReactNode } from "react";

export function DocumentPageGrid({
  steps,
  preview,
  panel,
  info,
}: {
  steps?: ReactNode;
  preview: ReactNode;
  panel?: ReactNode;
  info: ReactNode;
}) {
  return (
    <div
      className={
        "flex flex-col gap-y-5 [&>*]:shrink-0 xl:h-[--content-height] xl:min-h-[800px]"
      }
    >
      {steps && <div>{steps}</div>}

      {info}

      <div className={"h-[80vh] xl:h-auto xl:min-h-0 xl:grow"}>{preview}</div>

      {panel}
    </div>
  );
}
